export default "__VITE_ASSET__Dfh0St0K__"